// extracted by mini-css-extract-plugin
module.exports = {"Container":"PageLoad_Container__xUUpP","Content":"PageLoad_Content__URSVW","Loader":"PageLoad_Loader__cPJkL","spin":"PageLoad_spin__MAflJ"};